<template>
  <DatePicker
    :class="{ 'has-focus': hasFocus }"
    input-class="dp-input"
    v-model:setFocus="hasFocus"
    v-bind="{
      ...$attrs,
      onInvalid: () => $emit('invalid', new Error('must be a valid format'))
    }"
  />
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';
import DatePicker from '@ssi/vue-common/src/components/formControls/DatePicker';

export default {
  inheritAttrs: false,

  mixins: [focusable],

  components: { DatePicker },

  emits: ['invalid']
};
</script>

<style lang="scss" scoped>
:deep(.dp-input) {
  border: none;
  padding: 0;
  outline: none;
  width: 100%;
}
</style>
